module.exports = __webpack_public_path__ + "img/logo-house.ff801293.svg";